<script>
  import { createEventDispatcher, getContext, onDestroy } from "svelte";
  import { encode, decode, createRandomLayer } from "bitframes";

  import ColorPicker from "./ColorPicker.svelte";
  import { getPalette } from "../util/constants";
  import globalPrng from "../util/global-prng";
  import * as local from "../util/local.js";
  import Lock from "../icons/lock.svelte";
  import Dice from "../icons/dice2.svelte";

  export let encoding;
  export let decoded;

  // let lockedLayers = local.get("locked-layers", [
  //   false,
  //   false,
  //   false,
  //   false,
  //   false,
  // ]);
  // $: local.set("locked-layers", lockedLayers);

  const lockedLayers = getContext("lockedLayers");

  let _lockedLayers;
  onDestroy(
    lockedLayers.subscribe((v) => {
      _lockedLayers = v;
    })
  );

  let curPalette = getPalette({ system: encoding[0] });
  $: curPalette = getPalette({ system: encoding[0] });

  const COMPOSITION_LABEL = "Composition";
  const LOCK_LABEL = "Locked";
  const dispatch = createEventDispatcher();

  function toggleLock(i) {
    // lockedLayers.update((layers) => {
    //   layers = layers.slice();
    //   layers[i] = !layers[i];
    //   return layers;
    // });
  }

  function shiftToggleLock(ev, i) {
    if (ev.shiftKey) {
      ev.preventDefault();
      toggleLock(i);
    }
  }
</script>

<div class="layers-container">
  <div class="row">
    <div class="row-label"></div>
    <div class="row-content">
      {#each decoded.layers as layer, i}
        <div
          class="layer-index"
          role="none"
          on:click={(ev) => shiftToggleLock(ev, i)}
        >
          {#if _lockedLayers[i]}
            <div class="small-lock"><Lock></Lock></div>
          {:else}
            {i + 1}
          {/if}
        </div>
      {/each}
    </div>
  </div>
  <div class="row">
    <div class="row-label">Visible</div>
    <div class="row-content">
      {#each decoded.layers as layer, i}
        <div
          class="layer-visibility swatch-button"
          class:active={layer.visible}
          role="none"
          on:click={(ev) => {
            ev.preventDefault();
            if (ev.shiftKey) {
              toggleLock(i);
            } else {
              layer.visible = !layer.visible;
              dispatch("applyEncoding", decoded);
            }
          }}
        >
          <!-- {i + 1} -->
          <div class="visibility-icon"></div>
        </div>
      {/each}
    </div>
  </div>
  {#each [0, "swap", 1] as index}
    <div class="row">
      <div class="row-label">
        {#if index == 0}Color A{:else if index == 1}Color B{/if}
      </div>
      <div class="row-content">
        {#each decoded.layers as layer, i}
          {#if index == "swap"}
            <button
              class="swap-color swatch-button"
              class:disabled={!layer.visible ||
                layer.colors[0] === layer.colors[1]}
              disabled={!layer.visible}
              on:click={(ev) => {
                ev.preventDefault();
                if (ev.shiftKey) {
                  toggleLock(i);
                } else {
                  layer.colors.reverse();
                  dispatch("applyEncoding", decoded);
                }
              }}>↕</button
            >
          {:else}
            <ColorPicker
              enabled={layer.visible}
              id={layer.colors[index]}
              palette={curPalette}
              system={encoding[0]}
              on:shiftClick={(ev) => {
                toggleLock(i);
              }}
              on:select={(ev) => {
                const ret = ev.detail;
                if (ret) {
                  layer.colors[index] = ret.index;
                  dispatch("applyEncoding", decoded);
                }
              }}
            ></ColorPicker>
          {/if}
        {/each}
      </div>
    </div>
  {/each}
  {#each [COMPOSITION_LABEL] as rowType}
    <div class="row">
      <div class="row-label">{rowType}</div>
      <div class="row-content">
        {#each decoded.layers as layer, i}
          <div
            class="svg-button swatch-button"
            class:lockButton={rowType == LOCK_LABEL}
            class:locked={_lockedLayers[i]}
            class:disabled={rowType !== LOCK_LABEL && !layer.visible}
            role="none"
            on:click={(ev) => {
              if (ev.shiftKey) {
                toggleLock(i);
                return;
              }
              if (layer.visible || rowType == LOCK_LABEL) {
                ev.preventDefault();
                if (rowType === COMPOSITION_LABEL) {
                  const randoms = createRandomLayer();
                  Object.assign(layer, randoms, {
                    visible: layer.visible,
                    // dimensions: layer.dimensions,
                    colors: layer.colors,
                  });
                } else if (rowType == LOCK_LABEL) {
                  lockedLayers.update((layers) => {
                    layers = layers.slice();
                    layers[i] = !layers[i];
                    return layers;
                  });
                }
                dispatch("applyEncoding", decoded);
              }
            }}
          >
            {#if rowType == COMPOSITION_LABEL}
              <Dice></Dice>
            {:else}
              <Lock />
            {/if}
          </div>
        {/each}
      </div>
    </div>
  {/each}
</div>

<style>
  .layers-container {
    --swatch-cell-size: 40px;
    --border-radius: 0px;
    width: 100%;
    /* max-width: 200px; */
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .row {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
  }
  .row + .row {
  }
  .row-label {
    /* display: none; */
    font-size: 12px;
    flex-basis: 100px;
    padding-right: 10px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .row-content {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
  .swatch-button,
  .layer-index,
  .small-lock {
    min-height: 16px;
    background: none;
    width: var(--swatch-cell-size);
    height: var(--swatch-cell-size);
    --button-background-color: hsl(0, 0%, 95%);
    border-radius: 0;
    /* border: 1px solid black; */
    cursor: default;
    padding: 0;
    margin: 0;
    /* opacity: 0; */
    appearance: none;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    align-items: center;
    background: var(--button-background-color);
    border-radius: var(--border-radius);
    /* border-radius: 33px; */
    opacity: 1;
    cursor: pointer;
    position: relative;
  }
  .small-lock {
    position: absolute;
    /* top: 0; */
    /* left: 0; */
    /* transform: translateY(0px); */
    padding: 13px;
    background: none;

    /* width: 12px;
    height: 12px;
    background: pink;
     */
  }
  :global(.small-lock svg) {
    height: 100%;
    width: 100%;
    /* background: red; */
  }
  .layer-index {
    cursor: default;
    background: none;
    height: auto;
    font-size: 10px;
    margin-bottom: -5px;
  }
  .swatch-button.disabled {
    visibility: hidden;
  }
  .layer-visibility {
    opacity: 1;
    cursor: pointer;
  }
  .layer-visibility.active {
    /* background: black;
    color: white; */
  }
  .lockButton {
    opacity: 0.25;
  }
  .lockButton.locked {
    opacity: 1;
  }
  .swap-color {
    height: calc(var(--swatch-cell-size) / 2);
    background: none;
    font-size: 14px;
  }
  .swap-color.disabled {
    visibility: hidden;
  }
  @media (hover: hover) {
    .swap-color.disabled:hover {
      background: initial;
    }
    .swap-color:hover {
      background: var(--button-background-color);
    }
  }
  .visibility-icon {
    width: 16px;
    height: 16px;
    border-radius: 100% 100%;
    border: 1px dashed black;
    box-sizing: border-box;
  }
  .active .visibility-icon {
    --background: black;
    background: var(--background);
    border: 1px solid var(--background);
  }
  /* 
  .random {
    opacity: 0.25;
  }
  .random.active {
    opacity: 1;
  } */
  .svg-button {
    /* background: none; */
  }
  :global(.svg-button svg) {
    padding: 9px;
    box-sizing: border-box;
    width: 100%;
    height: auto;
  }
</style>
